<template>
  <v-dialog
    v-model="pickPackage"
    fullscreen
    :scrim="false"
    persistent
    :rounded="false"
    transition="dialog-bottom-transition"
  >
    <v-card class="dialog-container">
      <v-toolbar dark color="black" elevation="0">
        <v-btn icon dark @click="closePickPackage" :ripple="false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ `${personData.packageName} package` }}
        </v-toolbar-title>
      </v-toolbar>
      <div class="">
        <v-row class="no-gutters">
          <v-col class="col-12 col-md-2">
            <ul class="package-list">
              <li
                class="subtitle-2"
                :class="{ active: packageOption === 'info' }"
                @click="selectPackageOption('info')"
              >
                <v-icon class="mr-2" color="primary"
                  >mdi-information-outline</v-icon
                >
                Package Info
              </li>
              <li
                class="subtitle-2"
                :class="{ active: packageOption === 'upgrade' }"
                @click="selectPackageOption('upgrade')"
              >
                <v-icon class="mr-2" color="green">mdi-arrow-up</v-icon>
                Upgrade package
              </li>
              <li
                class="subtitle-2"
                :class="{ active: packageOption === 'downgrade' }"
                @click="selectPackageOption('downgrade')"
              >
                <v-icon class="mr-2" color="red">mdi-arrow-down</v-icon>
                Downgrade package
              </li>
              <li
                class="subtitle-2"
                :class="{ active: packageOption === 'cancel' }"
                @click="selectPackageOption('cancel')"
              >
                <v-icon class="mr-2" color="red">mdi-cancel</v-icon>
                Cancel subscription
              </li>
              <li
                class="subtitle-2"
                :class="{ active: packageOption === 'deleteAccount' }"
                @click="selectPackageOption('deleteAccount')"
              >
                <v-icon class="mr-2" color="red">mdi-delete</v-icon>
                Delete account
              </li>
            </ul>
          </v-col>

          <v-col class="col-12 col-md-10">
            <div class="px-4 py-4" v-if="packageOption === 'info'">
              <h3 class="mb-4">Package Info</h3>
              <div class="package-container">
                <div class="selected-package" v-if="pickedPackage">
                  <div
                    class="free-always"
                    v-if="pickedPackage.name == 'Premium'"
                  >
                    <p>
                      <strong>{{ lang.addMemories.freeAlways }}</strong>
                    </p>
                  </div>
                  <div
                    class="package-switch"
                    v-else-if="pickedPackage.name != 'Free'"
                  >
                    <span class="switch-label">Yearly</span>
                      <!-- :disabled="pickedPackage.name != selectedPackage" -->
                    <v-switch
                      v-model="pickedPackage.type"
                      :value="'monthly'"
                      inset
                      class="mr-0"
                      color="white"
                      :ripple="false"
                      hide-details
                    ></v-switch>
                    <span class="switch-label">Monthly</span>
                  </div>

                  <div class="d-flex align-center">
                    <p class="subtitle-1 font-weight-bold mt-0 mb-1">
                      {{ pickedPackage.name }}
                    </p>
                    <v-spacer></v-spacer>
                    <!-- <p class="title mt-0 cross-over">
                      €{{ pickedPackage.priceMonth }}
                    </p>
                    <span class="subtitle-2 pt-2 grey--text"
                      >/{{ lang.addMemories.perMonth }}</span
                    > -->
                  </div>
                  <v-divider class="mb-2"></v-divider>
                  <p class="subtitle-2">
                    <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >{{ pickedPackage.images }} images
                  </p>
                  <p class="subtitle-2">
                    <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >{{ pickedPackage.videos }} videos
                  </p>
                  <p class="subtitle-2">
                    <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >{{ pickedPackage.documents }} documents
                  </p>
                  <p class="subtitle-2">
                    <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >{{ pickedPackage.lastGreetings }} last greetings
                  </p>
                  <p class="subtitle-2">
                    <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >{{ pickedPackage.biography }} timelines <br /><span
                      class="caption green--text pl-5"
                      >{{ pickedPackage.biographyDescription }}</span
                    >
                  </p>
                  <p class="subtitle-2">
                    <v-icon
                      v-if="pickedPackage.likes === 'Yes'"
                      class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon
                      v-else
                      class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                      >mdi-close-circle-outline</v-icon
                    >Likes
                  </p>
                  <p class="subtitle-2">
                    <v-icon
                      v-if="pickedPackage.imageAndVideoInfo === 'Yes'"
                      class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon
                      v-else
                      class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                      >mdi-close-circle-outline</v-icon
                    >Image and video info
                  </p>
                  <p class="subtitle-2">
                    <v-icon
                      v-if="pickedPackage.bookmarks === 'Yes'"
                      class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon
                      v-else
                      class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                      >mdi-close-circle-outline</v-icon
                    >Bookmarks
                  </p>
                  <p class="subtitle-2">
                    <v-icon
                      v-if="pickedPackage.comments === 'Yes'"
                      class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                      >mdi-check-circle</v-icon
                    >
                    <v-icon
                      v-else
                      class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                      >mdi-close-circle-outline</v-icon
                    >Video and image comments
                  </p>
                  <v-divider class="mt-2"></v-divider>
                  <div class="d-flex align-center">
                    <p class="subtitle-1 pt-2 font-weight-bold">Active until</p>
                    <span
                      class="subtitle-2 pt-2 blue--text lighten-4 font-weight-bold"
                      >{{ personData.activeUntil | shortDate }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="px-4 py-4" v-if="packageOption === 'upgrade'">
              <h3 class="mb-4">Upgrade Package</h3>
              <v-alert
                v-if="personData.packageName == 'Free always - Premium'"
                color="white"
                border="left"
                elevation="1"
              >
                <p class="mb-0 white--black">
                  You are already using the maximum package and it's free
                  forever.
                </p>
              </v-alert>
              <v-alert
                v-else-if="personData.packageName == 'Premium'"
                color="white"
                border="left"
                elevation="1"
              >
                <p class="mb-0 white--black">
                  You are already on the highest package subscription.
                </p>
              </v-alert>
              <v-card class="px-0">
                <v-card-text class="gc-table px-0">
                  <div class="package-container-upgrade">
                    <!-- @click="selectPackage(p.name)" -->
                    <!-- :class="{
                      'selected-package': selectedPackage === p.name,
                      'greyed-out':
                        selectedPackage !== p.name && selectedPackage !== '',
                    }" -->
                  <div
                    v-for="(p, index) in upgradePackages"
                    :key="p.name + index"
                  >
                    <div class="free-always" v-if="p.name == 'Premium'">
                      <p>
                        <strong>{{ lang.addMemories.freeAlways }}</strong>
                      </p>
                    </div>
                    <div class="package-switch" v-else-if="p.name != 'Free'">
                      <span class="switch-label">Yearly</span>
                        <!-- :disabled="p.name != selectedPackage" -->
                      <v-switch
                        v-model="p.type"
                        :value="'monthly'"
                        inset
                        class="mr-0"
                        color="white"
                        :ripple="false"
                        hide-details
                      ></v-switch>
                      <span class="switch-label">Monthly</span>
                    </div>

                    <div class="d-flex align-center">
                      <p class="subtitle-1 font-weight-bold mt-0 mb-1">
                        {{ p.name }}
                      </p>
                      <v-spacer></v-spacer>
                      <p class="title mt-0 cross-over">€{{ p.priceMonth }}</p>
                      <span class="subtitle-2 pt-2 grey--text"
                        >/{{ lang.addMemories.perMonth }}</span
                      >
                    </div>
                    <v-btn
                      width="100%"
                      elevation="0"
                      color="blue lighten-1"
                      outlined
                      large
                      rounded
                      class="mt-1 mb-3 show-mobile"
                      @click="nextStep(5)"
                      >{{
                        p.name == "Premium"
                          ? lang.actions.createFreeProfile
                          : lang.actions.createProfile
                      }}</v-btn
                    >
                    <v-divider class="mb-2"></v-divider>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.images }} images
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.videos }} videos
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.documents }} documents
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.lastGreetings }} last greetings
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.biography }} timelines <br /><span
                        class="caption green--text pl-5"
                        >{{ p.biographyDescription }}</span
                      >
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.likes === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Likes
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.imageAndVideoInfo === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Image and video info
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.bookmarks === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Bookmarks
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.comments === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Video and image comments
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.suggestPhoto === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Followers can suggest photos
                    </p>
                    <v-divider class="mt-2"></v-divider>
                    <div class="d-flex align-center">
                        <!-- :class="{
                          'cross-over': p.type == 'monthly' && p.name != 'Free',
                          'blue--text lighten-4':
                            (p.name == 'Free' && p.name == selectedPackage) ||
                            (p.type != 'monthly' && p.name == selectedPackage),
                        }" -->
                      <p
                        class="title mt-2 mb-0"
                      >
                        €{{ p.priceYear }}
                      </p>
                        <!-- :class="{
                          'blue--text lighten-4':
                            (p.name == 'Free' && p.name == selectedPackage) ||
                            (p.type != 'monthly' && p.name == selectedPackage),
                          'grey--text':
                            p.name != 'Free' &&
                            p.type &&
                            p.name == selectedPackage,
                        }" -->
                      <span
                        class="subtitle-2 pt-2"
                        >/{{ lang.addMemories.perYear }}</span
                      >
                    </div>
                  </div>
                </div>
                  <!-- <div v-for="item in upgradePackages" :key="item.name">
                    <p>
                      <span>Images</span>
                      <span>{{ personData.images.length }}</span>
                      <span>{{ item.images }}</span>
                    </p>
                    <p>
                      <span>Videos</span>
                      <span>{{ personData.videos.length }}</span>
                      <span>{{ item.videos }}</span>
                    </p>

                    <p>
                      <span>Documents</span>
                      <span>{{ personData.documents.length }}</span>
                      <span>{{ item.documents }}</span>

                    </p>

                    <p>
                      <span>Last greetings</span>
                      <span>{{ personData.lastGreetings.length }}</span>
                      <span>{{ item.lastGreetings }}</span>
                    </p>
                  </div> -->
                </v-card-text>
              </v-card>
            </div>
            <div class="px-4 py-4" v-if="packageOption === 'downgrade'">
              <h3 class="mb-4">Downgrade Package</h3>
            </div>
            <div class="px-4 py-4" v-if="packageOption === 'cancel'">
              <h3 class="mb-4">Cancel Subscription</h3>
            </div>
            <div class="px-4 py-4" v-if="packageOption === 'deleteAccount'">
              <h3 class="mb-4">Delete Account</h3>
              <div>
                <v-alert
                  class="d-flex align-center"
                  colored-border
                  color="red"
                  border="left"
                  elevation="1"
                >
                  <v-icon class="mr-1" color="red"
                    >mdi-alert-circle-outline</v-icon
                  >
                  <span class="mb-0 white--black">
                    Deleting account for
                    <strong v-if="personMetrics.isHuman"
                      >{{ personData.firstName }}
                      {{ personData.lastName }}</strong
                    >
                    <strong v-else>{{ personData.name }}</strong>
                    will remove all data from our platform. This action is
                    irreversible. Proceed with caution!
                  </span>
                </v-alert>
                <v-btn
                  class="mt-4 white--text"
                  elevation="0"
                  color="red"
                  @click="deleteProfileModal"
                  >Delete Account Permanently</v-btn
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import packagesList from "../../script/packages.js";

export default {
  name: "PickPackage",
  data() {
    return {
      packageOption: "info",
    };
  },
  props: {
    pickPackage: {
      type: Boolean,
      default: false,
    },
    personData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    personMetrics: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    upgradePackages() {
      return packagesList.packages.filter(el => el.name != "Free always - Premium");
    },
    lang() {
      return this.$store.state.langObj || {};
    },


    pickedPackage() {
      var deceasedPackageName =
        this.personData.packageName == "Free always - Premium"
          ? "Premium"
          : this.personData.packageName;

      var packagePicked = packagesList.packages.find(
        (el) => el?.name === deceasedPackageName
      );
      return packagePicked;
    },
  },
  methods: {
    closePickPackage() {
      this.$emit("closePickPackage");
    },
    selectPackageOption(packageOption) {
      this.packageOption = packageOption;
    },
    deleteProfileModal() {
      this.$emit("deleteProfileModal");
    },
  },
};
</script>


<style lang="scss" scoped>
.gc-table {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  // > div {
  //   flex: 1 0 20%;
  //   border-right: 1px solid #ccc;
  //   padding: 10px;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: space-between;
  //   align-items: center;
  //   &:last-child {
  //     border-right: none;
  //   }
  //   p {
  //     display: flex;
  //     justify-content: flex-end;
  //     align-items: flex-end;
  //     width: 100%;
  //     span {
  //       padding-left: 5px;
  //       flex: 30% 0 0;
  //       text-align: right;
  //       font-size: 13px;
  //       &:first-child {
  //       font-size: 14px;
  //         flex: 40% 0 0;
  //         padding-left: 0;
  //         text-align: left;
  //       }
  //     }
  //   }
  // }

}

.package-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 30px;
  > div {
    flex: 0 0 100%;
    margin: 7px;
    border: 1px solid #ccc;
    border-top: 48px solid #ccc;
    border-radius: 4px;
    padding: 10px;
    margin: 0 0 20px 0;
    box-sizing: border-box;
    width: 100%;
    transition: all 0.3s;
    position: relative;
    .show-mobile {
      display: none !important;
    }
    @media only screen and (max-width: 1050px) {
      flex: 0 0 calc(30% - 14px);
    }
    @media only screen and (max-width: 600px) {
      .show-mobile {
        display: block !important;
      }
      flex: 0 0 calc(100% - 14px);
      &:nth-child(5) {
        order: 1;
      }
      &:nth-child(4) {
        order: 2;
      }
      &:nth-child(3) {
        order: 3;
      }
      &:nth-child(2) {
        order: 4;
      }
      &:nth-child(1) {
        order: 5;
      }
    }
    &.selected-package {
      border: 1px solid #f0f0f0 !important;
      border-top: 48px solid #2196f3 !important;
    }
    .free-always {
      position: absolute;
      top: -40px;
      p {
        color: #fff !important;
        font-size: 16px;
        strong {
          text-transform: uppercase;
        }
      }
    }
    &.greyed-out {
      opacity: 0.5;
      .v-btn {
        background-color: #ccc;
        color: #fff !important;
      }
    }
  }
  p {
    margin: 5px;
  }
}

.package-list {
  list-style: none;
  height: calc(100vh - 65px);
  overflow: auto;
  padding: 0;
  margin: 0;
  border-right: 1px solid #e0e0e0;
  width: 100%;
  background-color: #fff;
  li {
    padding: 15px 10px;
    border-bottom: 1px solid #e0e0e0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    color: #000;
    transition: all 0.3s ease;
    font-family: 'Roboto', sans-serif;
    &:hover {
      background-color: #f0f0f0;
    }
    &.active {
      background-color: #f0f0f0;
    }
  }
}

.package-container-upgrade {
  .package-switch {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  .switch-label {
    margin: 0;
    padding: 0;
    font-weight: 600;
    font-size: 14px;
    color: #ccc;
    margin: 17px 15px 0 0px;
  }
}
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-bottom: 0;
  width: 100%;
  > div {
    cursor: pointer;
    flex: 0 0 calc(20% - 14px);
    min-width: 20%;
    margin: 7px;
    border: 1px solid #ccc;
    border-top: 48px solid #ccc;
    border-radius: 0;
    padding: 10px;
    margin: 0 0 0 0;
    box-sizing: border-box;
    width: 100%;
    transition: all 0.3s;
    position: relative;
    .show-mobile {
      display: none !important;
    }
    @media only screen and (max-width: 1050px) {
      flex: 0 0 calc(30% - 14px);
    }
    @media only screen and (max-width: 600px) {
      .show-mobile {
        display: block !important;
      }
      flex: 0 0 calc(100% - 14px);
      &:nth-child(5) {
        order: 1;
      }
      &:nth-child(4) {
        order: 2;
      }
      &:nth-child(3) {
        order: 3;
      }
      &:nth-child(2) {
        order: 4;
      }
      &:nth-child(1) {
        order: 5;
      }
    }
    &.selected-package {
      border: 1px solid #2196f3 !important;
      border-top: 48px solid #2196f3 !important;
      .v-btn {
        background-color: #2196f3 !important;
        color: #fff !important;
      }
    }
    .free-always {
      position: absolute;
      top: -40px;
      p {
        color: #fff !important;
        font-size: 16px;
        strong {
          text-transform: uppercase;
        }
      }
    }
    &.greyed-out {
      opacity: 0.5;
      .v-btn {
        background-color: #ccc;
        color: #fff !important;
      }
    }
  }
  p {
    margin: 5px;
  }
}
.cross-over {
  text-decoration: line-through;
}
</style>


